module.exports = __webpack_public_path__ + "img/brgeo-logo.751739ed.png";